import { SEGMENT_MARKET_JS_KEY } from '../helpers/globals';

const SEGMENT_METHODS = [
  'trackSubmit',
  'trackClick',
  'trackLink',
  'trackForm',
  'pageview',
  'identify',
  'reset',
  'group',
  'track',
  'ready',
  'alias',
  'debug',
  'page',
  'once',
  'off',
  'on',
];

// Allow running in node for server-side rendering
if (typeof window !== 'undefined') {
  // This block taken from https://segment.com/docs/sources/website/analytics.js/quickstart ,
  // and modified to remove defensive code that prevents it being initialized twice

  const segment = [];
  window.analytics = segment; // The segment script (loaded async) overwrites `window.analytics`

  // Define a factory to create stubs. These are placeholders
  // for methods in Analytics.js so that you never have to wait
  // for it to load to actually record data. The `method` is
  // stored as the first argument, so segment can replay the data.
  segment.factory = function(method) {
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      segment.push(args);
      return segment;
    };
  };

  // For each segment method, generate a queueing stub.
  for (var i = 0; i < SEGMENT_METHODS.length; i++) {
    var key = SEGMENT_METHODS[i];
    segment[key] = segment.factory(key);
  }

  // Define a method to load Analytics.js from segment CDN
  segment.load = function(key) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src =
      ('https:' === document.location.protocol ? 'https://' : 'http://') +
      'cdn.segment.com/analytics.js/v1/' +
      key +
      '/analytics.min.js';

    // Insert our script next to the first script element.
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
  };

  segment.SNIPPET_VERSION = '4.0.0';
  segment.load(SEGMENT_MARKET_JS_KEY);
}

// The segment script overwrites window.analytics with a new object, so we can't
// directly export the `segment` object. Instead, export an object that delegates
// to `window.analytics`
const segmentWrapper = {};
SEGMENT_METHODS.forEach(methodName => {
  segmentWrapper[methodName] = function() {
    window.analytics[methodName](...arguments);
  };
});

export default segmentWrapper;
